export const analyticsSortRecord = {
    Default: 'RELEVANCE',
    DateDesc: 'LATEST_FIRST',
    PriceAsc: 'PRICE_ASC',
    PriceDesc: 'PRICE_DESC',
};
